import script from "./confirm.delete.action.vue?vue&type=script&setup=true&lang=ts"
export * from "./confirm.delete.action.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__